<template>    
    <BaseModal
        :id="'static'"
        :title="title"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_ext()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />

                <div class="w-100 table-responsive defaultproject__table overflow-y--1" v-show="project_tasks.length">
                    <table class="table">
                        <thead style="background-color: #f1f1f1;">
                            <tr>
                                <!-- <th>
                                    <span class="custom-control custom-checkbox">
                                        <input :id="`checkedMultipleUpdate`" type="checkbox" class="custom-control-input" v-model="step_code_multiple_update"/>
                                        <label :for="`checkedMultipleUpdate`" class="custom-control-label ml-2"/>
                                    </span>
                                </th> -->
                                <th v-for="(item, i) in task_table_headers" :key="i" scope="col" v-html="item.name"/>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in project_tasks" :key="i">
                                <td>
                                    <span class="custom-control custom-checkbox">
                                        <input :id="`projectTask${i}`" type="checkbox" class="custom-control-input" v-model="item.checked"/>
                                        <label :for="`projectTask${i}`" class="custom-control-label ml-2"/>
                                    </span>
                                </td>
                                <td v-html="item.name"/>
                                <td v-html="item.description"/>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources  from './form_resources'
import Resources      from './resources'
import FormDynamic    from '@/components/FormDynamic.vue'
import Breadcrumb     from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal      from '@/components/BaseModal'
import CentralButtons from '@/components/CentralButtons'

export default {

    name:   'FormModal',
    props: [
        "title",
        "rest_api",
        "notyf",
        "axios",
        "array_options",
        "project_tasks",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            levels:             [],
            areas:              [],
            form_format:        FormResources.form_format,
            form_data:          FormResources.form_data,
            form_backup:        {...FormResources.form_data},
            task_table_headers: Resources.task_table_headers,
        }
    },

    methods:{

        async form_submit_ext()
        {
            let project_filter = this.project_tasks.filter(item => item.checked)

            if(project_filter.length)
            {
                this.form_data.task_id = project_filter.map(item => item.id)
            }
            await this.form_submit()
            this.form_data.task_id.splice(0, this.form_data.task_id.length)
            this.restoreProjects()
        },

        restoreProjects()
        {
            this.project_tasks.map((item, i) => {
                item.checked = false
                window.$(`#projectTask${i}`).prop('checked', false)
            })
        }

    },

    mounted(){
    }
    
}
</script>